import { BasePayloadMapper } from '@ps/utils';
import type { HighCpiConfirmationActivityLog } from '@ps/survey-kernel';

import type { SurveyActivityLogPayloadDto } from '../dtos/survey-activity-log.dto';

const ACTIVITY_LOG_PLATFORM = 'Platform (new) UI';
const ACTIVITY_LOG_ORIGIN = 'UI';

export class SurveyActivityLogPayloadMapper extends BasePayloadMapper<
  HighCpiConfirmationActivityLog,
  SurveyActivityLogPayloadDto
> {
  public toPayload(
    log: HighCpiConfirmationActivityLog,
  ): SurveyActivityLogPayloadDto {
    return {
      eventSource: log.eventSource ?? 'user',
      logMessage: log.logMessage,
      surveyId: log.surveyId,
      metadata: log.metadata,
      platform: ACTIVITY_LOG_PLATFORM,
      origin: ACTIVITY_LOG_ORIGIN,
    };
  }
}
